/*
  To do
  - Show/hide read_more
    If description is taller than the wrapper, show the read_more btn

  - Open/close item
    Trigger is going to be the read_more btn
    - So this is only needed if read_more is showing

  - ...
*/

class WDNUpsellServices extends HTMLElement {
  constructor() {
    super();

    this.items_with_active_read_more = [];
    this.active_item;
  }

  get itemsAndChildren() {
    const ITEM_NODES = this.querySelectorAll(".upsell-services__item");
    let itemsAndChildren = [];

    if (!ITEM_NODES || ITEM_NODES.length === 0) return false;

    // Gather all the needed nodes
    ITEM_NODES.forEach((item) => {
      itemsAndChildren.push({
        item: item,
        read_more_btn: item.querySelector(".upsell-services__readmore-btn"),
        back_btn: item.querySelector(".upsell-services__back-btn"),
        description_wrapper: item.querySelector(
          ".upsell-services__description-wrapper"
        ),
        description: item.querySelector(".upsell-services__description"),
      });
    });

    return itemsAndChildren;
  }

  handleItemActivity(item_object) {
    if (!this.active_item) {
      this.classList.add("has-active-item");
      this.active_item = item_object.item;
      this.active_item.classList.add("active-item");
      return;
    }

    if (this.active_item === item_object.item) {
      this.classList.remove("has-active-item");
      this.active_item.classList.remove("active-item");
      this.active_item = false;
      return;
    }
  }

  handleReadmoreBtns() {
    // The whole description is visible when we only have 1 item, so we don't need read_more.
    if (this.querySelector('[data-item-count="1"]')) return;

    this.items.forEach((item_object) => {
      const DESCRIPTION_WRAPPER_HEIGHT =
        item_object.description_wrapper.getBoundingClientRect().height;

      const DESCRIPTION_HEIGHT =
        item_object.description.getBoundingClientRect().height;

      if (DESCRIPTION_HEIGHT > DESCRIPTION_WRAPPER_HEIGHT) {
        item_object.read_more_btn.classList.add("active-readmore");

        this.items_with_active_read_more.push(item_object);
      }
    });
  }

  bindItemEvents() {
    if (this.items_with_active_read_more.length === 0) return;

    this.items_with_active_read_more.forEach((item_object) => {
      item_object.read_more_btn.addEventListener("click", () => {
        this.handleItemActivity(item_object);
      });

      item_object.back_btn.addEventListener("click", () => {
        this.handleItemActivity(item_object);
      });
    });
  }

  connectedCallback() {
    this.items = this.itemsAndChildren;

    this.handleReadmoreBtns();
    this.bindItemEvents();
  }
}

customElements.define("wdn-upsell-services", WDNUpsellServices);

class WDNUpsellServicesItem extends HTMLElement {
  constructor() {
    super();
  }

  listenForSubmit() {
    this.boundClickEvent = this.handleSubmit.bind(this);
    this.btnSubmit.addEventListener("click", this.boundClickEvent);
  }

  onAddSuccess() {
    this.setAttribute("data-is-in-cart", "");
    this.is_in_cart = true;

    if (WDN.CartDrawer) {
      WDN.CartDrawer.refresh();
    } else {
      document.body.removeAttribute("data-loading");
      WDN.CartPage.refresh();
    }
  }

  onAddError() {
    this.isInCart = false;
    this.remove();
  }

  handleSubmit() {
    this.btnSubmit.setAttribute("disabled", "");

    var reqBody = {
      items: [
        {
          id: this.variant_id,
          quantity: 1,
          properties: {
            [this.property_name]: true,
          },
        },
      ],
    };

    if (!WDN.CartDrawer) {
      document.body.setAttribute("data-loading", "");
    }

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(reqBody),
    })
      .then((res) => res.json())
      .then((resJSON) => this.onAddSuccess(resJSON))
      .catch((error) => this.onAddError(error));
  }

  disconnectedCallback() {
    this.btnSubmit.removeEventListener("click", this.boundClickEvent);
  }

  connectedCallback() {
    this.variant_id = this.dataset.variantId;
    this.property_name = this.dataset.property;

    if (this.dataset.isInCart) this.is_in_cart = true;

    this.btnSubmit = this.querySelector(".upsell-services__btn");
    this.listenForSubmit();
  }
}

customElements.define("wdn-upsell-services-item", WDNUpsellServicesItem);
